// All Imports
import { APIMethod } from '../services/api.service';
/**
 * Model for handling parameters of http request
 */
interface INameToValueMap {
  [key: string]: any;
}
export class APIRequest {
  endpoint: string;
  method: APIMethod;
  private contentType: string;
  private keys: Array<string>;
  private values: Array<string>;
  private rawBody: any;
  private canHideSpinner: boolean = false;
  private OktaAccessToken: string;
  constructor(
    endpoint: string,
    method: APIMethod,
    canHideSpinner: boolean = false
  ) {
    this.endpoint = endpoint;
    this.method = method;
    this.keys = [];
    this.values = [];
    this.contentType = 'application/json';
    this.canHideSpinner = canHideSpinner;
  }
  addProperty(key: any, value: any) {
    this.keys.push(key);
    this.values.push(value);
  }
  addAll(data: any) {
    this.rawBody = data;
  }
  addOktaToken(oktaAccessToken: string) {
    this.OktaAccessToken = oktaAccessToken;
  }
  getOktaToken() {
    return this.OktaAccessToken;
  }
  getRawBody() {
    return this.rawBody;
  }
  getBody(): any {
    const rawData: INameToValueMap = {};
    for (let index = 0; index < this.keys.length; index++) {
      rawData[this.keys[index]] = this.values[index];
    }
    return JSON.stringify(rawData);
  }
  getCanHideSpinner() {
    return this.canHideSpinner;
  }
  getContentType() {
    return this.contentType;
  }
  setContentType(contentType: string) {
    this.contentType = contentType;
  }
  DownloadFile(response: any, type: string, fileInfo: any, error?: string) {
    let filename: string = '';
    if (type == 'text/plain') {
      filename = fileInfo.FileName.split('.')[0] + '.txt';
    } else {
      filename =
        error == 'Error'
          ? fileInfo.FileName.split('.')[0] + '.xls'
          : fileInfo.FileName;
    }
    let ext = filename.split('.')[1];
    if (ext.toLowerCase() == 'xls') {
      type = 'application/vnd.ms-excel';
    } else if (ext.toLowerCase() == 'xlsx') {
      type =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    }
    let blob = new Blob(
      [this.base64ToArrayBuffer(response.result.fileContents)],
      { type: type }
    );
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    link.click();
  }
  //...........................Use to Convert base64 file data into bytes
  base64ToArrayBuffer(base64) {
    let binaryString = window.atob(base64);
    let binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      let ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }
}
